<template>
  <div class="container sv019">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>お申し込みに必要な書類</HeadingOne>

    <p class="_mb-md-60 _mb-sm-40">
      新規お申し込み時にご提出いただく書類についてご案内します。
    </p>

    <div class="border-box">
      <p class="txt01">
        <img
          src="@/assets/images/icons/exclamation.svg"
          class="img-fluid _mr-10 exclamation"
          alt=""
        />お申し込みお手続きの際に、金融機関の口座をご登録いただいたお客さまはご本人さま確認書類のご提出は不要となります。
      </p>
      <p>
        金融機関の支店名・口座番号などのご入力が必要となるため、通帳・キャッシュカードなどをお手元にご準備ください。
      </p>
    </div>

    <HeadingTwo>ご本人さま確認書類をアップロードする場合</HeadingTwo>

    <p class="_mb-md-50 _mb-sm-40">
      お申し込み時に、現住所が記載されたご本人さま確認書類のご提出が必要となります。各書類の有効期限をご確認のうえ、ご提出ください。
    </p>

    <section>
      <HeadingThree>いずれかの2点をご用意ください。</HeadingThree>

      <ListGroup class="-note">
        <ListItem class="-note"
          >ご提出にあたっては必ず注意事項をご確認のうえお手続きください。</ListItem
        >
      </ListGroup>

      <div class="document-wrap01 _mt-md-30 _mt-sm-20 _mb-md-40 _mb-sm-30">
        <div class="document-box _mr-md-10 _pr-sm-5">
          <img
            src="@/assets/images/sv/sv019/img01.gif"
            class="img-fluid _mb-md-10 _mb-sm-5"
            alt=""
          />
          <p>運転免許証</p>
        </div>
        <div class="document-box _ml-md-10 _mr-md-10 _pl-sm-5">
          <img
            src="@/assets/images/sv/sv019/img02.gif"
            class="img-fluid _mb-md-10 _mb-sm-5"
            alt=""
          />
          <p>運転経歴証明書</p>
        </div>
        <div class="document-box _ml-md-10 _pr-sm-5">
          <img
            src="@/assets/images/sv/sv019/img03.gif"
            class="img-fluid _mb-md-10 _mb-sm-5"
            alt=""
          />
          <p>パスポート</p>
        </div>
        <div class="document-box _ml-md-10 _mr-md-10 _pl-sm-5">
          <img
            src="@/assets/images/sv/sv019/img04.gif"
            class="img-fluid _mb-md-10 _mb-sm-5"
            alt=""
          />
          <p>健康保険証</p>
        </div>
        <div class="document-box _ml-md-10 _pr-sm-5">
          <img
            src="@/assets/images/sv/sv019/img05.gif"
            class="img-fluid _mb-md-10 _mb-sm-5"
            alt=""
          />
          <p>マイナンバーカード<br />(顔写真付き)</p>
        </div>
      </div>
    </section>

    <section class="_mb-md-20 _mb-sm-20">
      <div class="document-wrap02 _mt-md-30 _mt-sm-20">
        <div class="document-bg">
          <p class="txt01 _mb-0">
            上記の書類を2点ご用意いただけない場合は、上記書類1点に加えて、現住所が記載された以下の書類のいずれか1点のご提出でもお手続きいただけます。
          </p>
          <ListGroup class="-normal _mt-20">
            <ListItem class="-normal"
              >住民票の写し
              <ListGroup class="-note">
                <ListItem class="-note">発行から6ヶ月以内のもの</ListItem>
              </ListGroup>
            </ListItem>
            <ListItem class="-normal"
              >国税・地方税の領収書または納税証明書/社会保険料の領収書
              <ListGroup class="-note">
                <ListItem class="-note">発行から6ヶ月以内のもの</ListItem>
              </ListGroup>
            </ListItem>
            <ListItem class="-normal"
              >公共料金の領収書（電気、都市ガス、水道、NHK、固定電話）
              <ListGroup class="-note">
                <ListItem class="-note">発行から6ヶ月以内のもの</ListItem>
              </ListGroup>
            </ListItem>
          </ListGroup>
        </div>
      </div>
    </section>

    <p class="_mb-md-10 _mb-sm-10">
      書類を2点ご用意いただけない場合はコールセンターへお問い合わせください。
    </p>
    <p class="_mb-md-60 _mb-sm-40">
      <router-link :to="{ name: 'sv036' }" class="contact"
        >お問い合わせはこちら</router-link
      >
    </p>

    <section class="_mb-md-40 _mb-sm-40">
      <CardBox class="_mb-10">
        <CardHeader>
          <BtnToggle collapse-target="accordion0" class="-plus">
            <h2 class="heading">ご提出にあたっての注意事項</h2>
          </BtnToggle>
        </CardHeader>
        <CollapseItem id="accordion0" accordion="accordion0" :visible="false">
          <CardBody>
            <ListGroup class="-normal _mb-0">
              <ListItem class="-normal"
                >運転免許証・運転経歴証明書は、裏面に記載がある場合のみ裏面も撮影してご提出ください。</ListItem
              >
              <ListItem class="-normal"
                >パスポートは、所持人記入欄にご自身のお名前・住所が記載されているかをご確認のうえ、撮影してご提出ください。</ListItem
              >
              <ListItem class="-normal"
                >カード型タイプの健康保険証は、裏面に住所が記載されているかをご確認のうえ、撮影してご提出ください。</ListItem
              >
              <ListItem class="-normal"
                >マイナンバーカード（顔写真付き）は、表面のみ撮影してご提出ください。</ListItem
              >
              <ListItem class="-normal"
                >通知カード（写真なし）はご本人さま確認資料としてご利用できません。</ListItem
              >
              <ListItem class="-normal"
                >お名前・住所・生年月日がお申し込みいただいた内容と同じであることをご確認のうえ、ご提出してください。</ListItem
              >
              <ListItem class="-normal"
                >書類に個人番号（マイナンバー）、本籍地、健康保険証の保険者番号・記号・番号（介護保険の被保険者証および自衛官診療証を含む）等が記載されている場合は、紙などで隠して撮影してください。</ListItem
              >
              <ListItem class="-normal"
                >上記以外の注意事項については、お申し込み画面にてご確認ください。</ListItem
              >
            </ListGroup>
          </CardBody>
        </CollapseItem>
      </CardBox>
    </section>

    <section class="_mb-md-120 _mb-sm-60">
      <CardBox class="_mb-10">
        <CardHeader>
          <h2 class="heading">日本国籍をお持ちでない方</h2>
        </CardHeader>
        <CardBody>
          <p>以下のいずれかの書類もあわせてご提出が必要となります。</p>
          <ListGroup class="-normal _mb-0">
            <ListItem class="-normal">在留カード</ListItem>
            <ListItem class="-normal">特別永住者証明書</ListItem>
          </ListGroup>
        </CardBody>
      </CardBox>
    </section>

    <section class="_mb-md-120 _mb-sm-60">
      <HeadingTwo>撮影時のポイント</HeadingTwo>
      <div class="point-box _mb-md-30">
        <div class="point-img _mb-sm-30 _pr-md-20">
          <p class="txt01 _mb-md-30">
            <img
              src="@/assets/images/icons/circle-orange.svg"
              class="img-fluid _mr-md-20"
              alt=""
            />よい例
          </p>
          <img
            src="@/assets/images/sv/sv019/img06.jpg"
            class="img-fluid _mr-1"
            alt=""
          /><img
            src="@/assets/images/sv/sv019/img07.jpg"
            class="img-fluid _ml-1"
            alt=""
          />
          <ListGroup class="-normal _mt-15">
            <ListItem class="-normal">文字がはっきり読める</ListItem>
            <ListItem class="-normal">書類全体が写っている</ListItem>
          </ListGroup>
        </div>
        <div class="point-img _pl-md-20">
          <p class="txt01 _mb-md-30">
            <img
              src="@/assets/images/icons/close-gray.svg"
              class="img-fluid _mr-md-20"
              alt=""
            />悪い例
          </p>
          <img
            src="@/assets/images/sv/sv019/img08.jpg"
            class="img-fluid _mr-1"
            alt=""
          /><img
            src="@/assets/images/sv/sv019/img09.jpg"
            class="img-fluid _ml-1"
            alt=""
          />
          <ListGroup class="-normal _mt-15">
            <ListItem class="-normal">画像がぼやけている</ListItem>
            <ListItem class="-normal">写真が切れている</ListItem>
          </ListGroup>
        </div>
      </div>
      <ListGroup class="-note">
        <ListItem class="-note">画像はイメージになります。</ListItem>
        <ListItem class="-note"
          >送付された画像に不備がある場合、当社よりお電話を差しあげることがございます。</ListItem
        >
      </ListGroup>
      <!--<btngroup-sv020en001></btngroup-sv020en001>-->
      <!--<h3>本人確認書類に関するよくあるご質問</h3>-->
      <!--<ul>-->
      <!--<li><router-link :to="{name: 'sv040'}">免許証を持っていなくても申し込めますか？</router-link></li>-->
      <!--<li><router-link :to="{name: 'sv040'}">ワンタイムパスワードをなくしてしまいました。</router-link></li>-->
      <!--<li><router-link :to="{name: 'sv040'}">オンライン口座振替とは何ですか？</router-link></li>-->
      <!--<li><router-link :to="{name: 'sv040'}">郵送なしで本人確認を行ってほしいのですが…。</router-link></li>-->
      <!--</ul>-->
    </section>

    <CvBox class="_mb-md-120 _mb-sm-60" />

    <section class="_mb-md-120 _mb-sm-60">
      <HeadingTwo>収入証明書のご提出について</HeadingTwo>
      <p>
        以下に該当する場合、ご契約前に収入証明書のご提出をお願いしております。
      </p>
      <ListGroup class="-normal">
        <ListItem class="-normal"
          >前回収入証明書をご提出いただいてから、２年以上経過している場合</ListItem
        >
        <ListItem class="-normal"
          >au PAY
          スマートローンのご利用限度額と他の貸金業者からのお借り入れ残高の合計が100万円を超える場合</ListItem
        >
        <ListItem class="-normal"
          >au PAY スマートローンのご利用限度額が50万円を超える場合</ListItem
        >
      </ListGroup>
      <ListGroup class="-link">
        <ListItem class="-link" router-name="sv057"
          >収入証明書について</ListItem
        >
      </ListGroup>
      <!--<btn-text routerName="sv057" class="-next">収入証明書類について</btn-text>-->
    </section>

    <ContactBox class="_mb-md-120 _mb-sm-60" />
  </div>
  <!-- container -->
</template>

<script>
import HeadingOne from "../components/heading/HeadingOne";
import HeadingTwo from "../components/heading/HeadingTwo";
import BtnToggle from "../components/button/BtnToggle";
import CardBox from "../components/card/CardBox";
import CardHeader from "../components/card/CardHeader";
import CardBody from "../components/card/CardBody";
import CollapseItem from "../components/collapse/CollapseItem";
import CvBox from "../components/box/CvBox";
import ContactBox from "../components/box/ContactBox";
import ListGroup from "../components/list/ListGroup";
import ListItem from "../components/list/ListItem";
import HeadingThree from "../components/heading/HeadingThree";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import { setMeta } from "@/utils/Meta";

export default {
  name: "Sv019",
  components: {
    HeadingThree,
    ListItem,
    ListGroup,
    ContactBox,
    CvBox,
    CollapseItem,
    CardBody,
    CardHeader,
    CardBox,
    BtnToggle,
    HeadingOne,
    HeadingTwo,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "お申し込みに必要な書類｜お申し込み条件・お手続きの流れ",
      description:
        "新規お申し込み時に必要なご本人さま確認資料について分かりやすくご説明します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,必要書類",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "お申し込み条件・お手続きの流れ",
          routerName: "sv045",
        },
        {
          text: "お申し込みに必要な書類",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/stylesheets/styles";

.sv019 {
  .border-box {
    border: 1px solid $secondary;
    border-radius: 10px;
    padding: 20px;
    @include mq-up(md) {
      padding: 30px;
      text-align: center;
    }
    > .txt01 {
      color: $danger;
      font-weight: bold;
      font-size: 16px;
      line-height: 28px;
      @include mq-up(md) {
        font-size: 20px;
      }
      img {
        vertical-align: sub;
      }
      > .exclamation {
        width: 18px;
        @include mq-up(md) {
          width: 25px;
        }
      }
    }
  }
  .contact {
    background-image: url("../assets/images/icons/arrow-right-gray.svg");
    background-position: right center;
    background-repeat: no-repeat;
    background-size: 8px 14px;
    display: inline-block;
    padding-right: 20px;
    font-size: 16px;
    @include mq-up(md) {
      font-size: 18px;
    }
  }
}

.document-wrap01 {
  display: flex;
  @include mq-down(md) {
    flex-wrap: wrap;
  }
  @include mq-up(md) {
    justify-content: center;
  }
  > .document-box {
    width: 50%;
    text-align: center;
    font-weight: bold;
    @include mq-up(md) {
      max-width: 280px;
      width: 100%;
    }
  }
}

.document-wrap02 {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  @include mq-down(md) {
    flex-wrap: wrap;
  }
  > .document-box {
    width: 50%;
    text-align: center;
    font-weight: bold;
    @include mq-up(md) {
      max-width: 280px;
      width: 100%;
    }
  }
  > .plus-box {
    width: 40px;
    @include mq-down(md) {
      width: 30px;
    }
    @include mq-up(md) {
      margin-top: 125px;
    }
  }
  > .document-bg {
    width: 100%;
    background-color: $success;
    border-radius: 10px;
    padding: 25px;
    @include mq-down(md) {
      padding-bottom: 20px;
    }
    @include mq-up(md) {
      padding: 30px 25px;
    }
    > .txt01 {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 15px;
      @include mq-up(md) {
        margin-bottom: 25px;
        font-size: 20px;
      }
    }
    > .list-group {
      > .list-item {
        list-style-type: decimal !important;
      }
    }
  }
}

.point-box {
  display: flex;
  flex-wrap: wrap;
  > .point-img {
    width: 100%;
    @include mq-up(md) {
      width: 50%;
    }
    > .txt01 {
      width: 100%;
      display: flex;
      align-items: center;
      font-weight: bold;
      img {
        width: 20px;
        @include mq-up(md) {
          width: 30px;
        }
      }
    }
    img {
      width: 50%;
      @include mq-down(md) {
        width: calc(50% - 2px);
      }
      @include mq-up(md) {
        max-width: 287px;
        width: 100%;
      }
    }
  }
}

.card-box {
  > .card-body {
    > .list-group {
      > .list-item {
        list-style-type: decimal !important;
      }
    }
  }
}

.point-box {
  > .point-img {
    > .list-group {
      > .list-item {
        list-style-type: disc;
      }
    }
  }
}
</style>
